// @flow
import React from 'react'
import styles from './Card.css'

type Props = {
  title?: any,
  children?: any,
  className?: string,
  variant?: 'default' | 'flat',
}

const Card = (props: Props) => {
  const { title = false, children, className, variant = 'default', ...rest } = props
  const base = variant === 'flat' ? styles.cardFlat : styles.card
  return (
    <section {...rest} className={`${base} ${className}`}>
      {title && <div className={styles.title}>{title}</div>}
      <div>{children}</div>
    </section>
  )
}

export default Card
